// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kricketune: PokeData = {
  "id": 402,
  "name": "kricketune",
  "height": 10,
  "weight": 255,
  "base_experience": 134,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "pound",
    "swords-dance",
    "tackle",
    "growl",
    "sing",
    "absorb",
    "screech",
    "focus-energy",
    "bide",
    "leech-life",
    "slash",
    "perish-song",
    "fury-cutter",
    "taunt",
    "aerial-ace",
    "night-slash",
    "x-scissor",
    "bug-buzz",
    "bug-bite",
    "struggle-bug",
    "sticky-web",
    "fell-stinger"
  ],
  "moves": [
    "tackle",
    "growl",
    "aerial-ace",
    "night-slash",
    "bug-buzz",
    "bug-bite",
    "sticky-web",
    "signal-spam",
    "pin-missile",
    "lunge",
    "pounce",
    "pin-rush",
    "heal-order"
  ],
  "evolution_chain": {
    "id": 208,
    "item": null,
    "species": [
      {
        "name": "kricketot",
        "order": 431,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kricketune",
        "order": 432,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 401,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 121,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
